// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"a8dab7bb","667":"1d94f236","966":"9e1abe6f"}[chunkId] + ".chunk.js";
};